package fr.frux.core.designsystem.layout

import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Mode d'affichage de l'app (spec 2026-09-10 webApp grand écran, §2). Deux valeurs seulement :
 * la classe intermédiaire Material 3 (600 à 840 dp, tablette en portrait) reste `Compact`, aucun
 * engagement n'est pris dessus. Le point de décision est unique : [fruxLayoutMode].
 */
enum class FruxLayoutMode { Compact, Expanded }

/** Posé par la racine (`App`), lu par les squelettes et, au lot 2, par `MapScreen`. */
val LocalFruxLayoutMode = staticCompositionLocalOf { FruxLayoutMode.Compact }

object FruxLayoutDefaults {
    /** Seuil « expanded » de Material 3. */
    val ExpandedMinWidth: Dp = 840.dp

    /** Colonne posée sur la carte (zone carte), spec §4. */
    val MapPanelWidth: Dp = 400.dp

    /**
     * Colonne des écrans de pleine zone (réglages, notifications), spec §6. Portée par l'écran
     * lui-même et non par l'hôte, qui garde [FullZoneWideMaxWidth] (#443).
     */
    val FullZoneMaxWidth: Dp = 640.dp

    /**
     * Largeur maximale d'un écran marqué large en pleine zone (Profil en deux colonnes, #443),
     * aligné contre le rail comme une colonne sur la carte. Au-delà, les lignes de liste
     * s'étiraient au point d'éloigner le libellé de son chevron.
     */
    val FullZoneWideMaxWidth: Dp = 1200.dp

    /** Part de largeur du panneau visuel de [SplitEntryLayout] en grand écran, spec §6. */
    const val ENTRY_VISUAL_FRACTION: Float = 0.45f

    /** Largeur maximale du contenu de [SplitEntryLayout] en grand écran, spec §6. */
    val EntryContentMaxWidth: Dp = 480.dp
}

fun fruxLayoutMode(widthDp: Int): FruxLayoutMode =
    if (widthDp >=
        FruxLayoutDefaults.ExpandedMinWidth.value.toInt()
    ) {
        FruxLayoutMode.Expanded
    } else {
        FruxLayoutMode.Compact
    }
